import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const WAITLIST_REMOVED = {
  type: GQL.message_template_type_enum.WaitlistRemoved,
  emailSubject:
    "You have been removed from the waitlist at {{waitlist.schoolName}} / Has sido removido de la lista de espera de {{waitlist.schoolName}}",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      {{student.name}} has been removed from the waitlist at
      {{waitlist.schoolName}}. If you have any questions please contact
      {{organization.name}}.<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      {{student.name}} ha sido retirado/a de la lista de espera en
      {{waitlist.schoolName}}. Si tiene alguna pregunta, por favor contacte a
      {{organization.name}}.<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

{{student.name}} has been removed from the waitlist at {{waitlist.schoolName}}. If you have any questions please contact {{organization.name}}.

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

{{student.name}} ha sido retirado/a de la lista de espera en {{waitlist.schoolName}}. Si tiene alguna pregunta, por favor contacte a {{organization.name}}.

-Equipo de {{organization.name}}`,
  sms: "{{student.name}} has been removed from the waitlist at {{waitlist.schoolName}} / {{student.name}} fue removido de la lista de espera en {{waitlist.schoolName}}",
};
